var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "lodash.pick", "../utils", "../interchange/fromEmacImage", "./getAvailabilityLabel"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("lodash.pick"), require("../utils"), require("../interchange/fromEmacImage"), require("./getAvailabilityLabel"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.objectWithoutProperties, global.lodash, global.utils, global.fromEmacImage, global.getAvailabilityLabel);
    global.fromEmacProgram = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _objectWithoutProperties2, _lodash, _utils, _fromEmacImage, _getAvailabilityLabel) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _lodash = _interopRequireDefault(_lodash);
  _fromEmacImage = _interopRequireDefault(_fromEmacImage);
  _getAvailabilityLabel = _interopRequireDefault(_getAvailabilityLabel);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var _default = function _default(translate) {
    var getLabel = (0, _getAvailabilityLabel.default)(translate);
    return function (_ref) {
      var kind = _ref.kind,
          images = _ref.images,
          duration = _ref.duration,
          shortDescription = _ref.shortDescription,
          fullDescription = _ref.fullDescription,
          availability = _ref.availability,
          stickers = _ref.stickers,
          program = (0, _objectWithoutProperties2.default)(_ref, ["kind", "images", "duration", "shortDescription", "fullDescription", "availability", "stickers"]);
      return _objectSpread(_objectSpread({}, (0, _lodash.default)(program, ['id', 'programId', 'url', 'title', 'subtitle', 'geoblocking', 'broadcastDates', 'renderLink' // Keep prop added for SPA
      ])), {}, {
        availability: availability,
        stickers: stickers,
        description: shortDescription || fullDescription,
        kind: kind,
        duration: (0, _utils.durationToMinutes)(duration),
        images: (0, _fromEmacImage.default)(images),
        beginsAt: getLabel({
          availability: availability,
          stickers: stickers
        })
      });
    };
  };

  _exports.default = _default;
});